// extracted by mini-css-extract-plugin
export var chatHtmlText = "_un-2";
export var chatLink = "_un-0";
export var chatText = "_un-1";